import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { Warnings, trackWarning } from "modules/monitoring";
import { checkFirebaseAccess } from "modules/systemCheck/utils/checkFirebaseAccess";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { selectFirebaseResult } from "../../redux/selectors";
import { setFirebaseResult } from "../../redux/systemCheckSlice";
import { withTimeout } from "../../../systemCheck/utils/withTimeout";
import { FIREBASE_TEST, firestoreRetryMethods } from "../constants";

export const FirebaseTest = () => {
  const dispatch = useAppDispatch();
  const { isDirty, isLoading } = useSelector(selectFirebaseResult);

  const { error } = useQuery({
    queryKey: [FIREBASE_TEST],
    queryFn: async () => {
      dispatch(
        setFirebaseResult({
          isLoading: true,
          isSuccessful: null,
          isDirty: false,
        }),
      );

      const result = await withTimeout(checkFirebaseAccess);

      dispatch(
        setFirebaseResult({
          isLoading: false,
          isSuccessful: result,
          isDirty: false,
        }),
      );
      return result;
    },
    enabled: isDirty && !isLoading,
    ...firestoreRetryMethods,
  });

  useEffect(() => {
    if (!error) return;

    dispatch(
      setFirebaseResult({
        isLoading: false,
        isSuccessful: false,
        isDirty: false,
      }),
    );

    trackWarning(Warnings.GEARTEST_FIREBASE_INACCESSIBLE, {
      message: `error encountered while performing firebase check "${error.message}"`,
    });
  }, [error, dispatch]);

  return null;
};
